var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wc-page",class:{
    'has-status-safe-area': _vm.needsStatusSafeArea,
    'is-ios-webview': _vm.isIOS
  },style:(_vm.pageStyle)},[(!_vm.isNewsDetail)?_c('div',{staticClass:"wc-page__header"},[_c('app-banner',{on:{"back":_vm.closeWebView}}),_c('main-tabs')],1):_vm._e(),_c('div',{staticClass:"wc-page__body",class:{ 'is-news-detail': _vm.isNewsDetail }},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }